import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/brand-guidelines',
    component: ComponentCreator('/brand-guidelines', 'a87'),
    exact: true
  },
  {
    path: '/chat',
    component: ComponentCreator('/chat', '4b9'),
    exact: true
  },
  {
    path: '/chat-rules',
    component: ComponentCreator('/chat-rules', 'be9'),
    exact: true
  },
  {
    path: '/code',
    component: ComponentCreator('/code', '309'),
    exact: true
  },
  {
    path: '/consulting',
    component: ComponentCreator('/consulting', 'c8b'),
    exact: true
  },
  {
    path: '/demo-submitted',
    component: ComponentCreator('/demo-submitted', '618'),
    exact: true
  },
  {
    path: '/jobs',
    component: ComponentCreator('/jobs', 'd2c'),
    exact: true
  },
  {
    path: '/jobs-en',
    component: ComponentCreator('/jobs-en', 'e2e'),
    exact: true
  },
  {
    path: '/legal-notice',
    component: ComponentCreator('/legal-notice', 'b0b'),
    exact: true
  },
  {
    path: '/license',
    component: ComponentCreator('/license', 'bdc'),
    exact: true
  },
  {
    path: '/license-preview',
    component: ComponentCreator('/license-preview', '80a'),
    exact: true
  },
  {
    path: '/markdown-page',
    component: ComponentCreator('/markdown-page', '3d7'),
    exact: true
  },
  {
    path: '/meeting',
    component: ComponentCreator('/meeting', 'b8a'),
    exact: true
  },
  {
    path: '/meeting-paid',
    component: ComponentCreator('/meeting-paid', '372'),
    exact: true
  },
  {
    path: '/meeting-paid-starter',
    component: ComponentCreator('/meeting-paid-starter', '666'),
    exact: true
  },
  {
    path: '/newsletter',
    component: ComponentCreator('/newsletter', 'c98'),
    exact: true
  },
  {
    path: '/premium',
    component: ComponentCreator('/premium', '40c'),
    exact: true
  },
  {
    path: '/premium-submitted',
    component: ComponentCreator('/premium-submitted', 'c98'),
    exact: true
  },
  {
    path: '/press',
    component: ComponentCreator('/press', '626'),
    exact: true
  },
  {
    path: '/privacy',
    component: ComponentCreator('/privacy', '8cc'),
    exact: true
  },
  {
    path: '/release',
    component: ComponentCreator('/release', '6b9'),
    exact: true
  },
  {
    path: '/search',
    component: ComponentCreator('/search', '5de'),
    exact: true
  },
  {
    path: '/sem/angular-database',
    component: ComponentCreator('/sem/angular-database', '4ab'),
    exact: true
  },
  {
    path: '/sem/browser-database',
    component: ComponentCreator('/sem/browser-database', 'baf'),
    exact: true
  },
  {
    path: '/sem/capacitor-database',
    component: ComponentCreator('/sem/capacitor-database', 'e71'),
    exact: true
  },
  {
    path: '/sem/electron-database',
    component: ComponentCreator('/sem/electron-database', '7ac'),
    exact: true
  },
  {
    path: '/sem/expo-database',
    component: ComponentCreator('/sem/expo-database', 'f40'),
    exact: true
  },
  {
    path: '/sem/firestore-alternative',
    component: ComponentCreator('/sem/firestore-alternative', '113'),
    exact: true
  },
  {
    path: '/sem/gaawsds1',
    component: ComponentCreator('/sem/gaawsds1', 'e39'),
    exact: true
  },
  {
    path: '/sem/gaawsds2',
    component: ComponentCreator('/sem/gaawsds2', '5a5'),
    exact: true
  },
  {
    path: '/sem/gaawsds3',
    component: ComponentCreator('/sem/gaawsds3', '8b1'),
    exact: true
  },
  {
    path: '/sem/gaawsds4',
    component: ComponentCreator('/sem/gaawsds4', '394'),
    exact: true
  },
  {
    path: '/sem/gaawsds5',
    component: ComponentCreator('/sem/gaawsds5', '355'),
    exact: true
  },
  {
    path: '/sem/gaawsds6',
    component: ComponentCreator('/sem/gaawsds6', '369'),
    exact: true
  },
  {
    path: '/sem/gads',
    component: ComponentCreator('/sem/gads', 'bb5'),
    exact: true
  },
  {
    path: '/sem/gadxie1',
    component: ComponentCreator('/sem/gadxie1', '9bb'),
    exact: true
  },
  {
    path: '/sem/gadxie2',
    component: ComponentCreator('/sem/gadxie2', 'd88'),
    exact: true
  },
  {
    path: '/sem/gadxie3',
    component: ComponentCreator('/sem/gadxie3', 'f1b'),
    exact: true
  },
  {
    path: '/sem/gaencdb1',
    component: ComponentCreator('/sem/gaencdb1', '991'),
    exact: true
  },
  {
    path: '/sem/gaencdb2',
    component: ComponentCreator('/sem/gaencdb2', '85f'),
    exact: true
  },
  {
    path: '/sem/gaencdb3',
    component: ComponentCreator('/sem/gaencdb3', '0de'),
    exact: true
  },
  {
    path: '/sem/gaidxdb1',
    component: ComponentCreator('/sem/gaidxdb1', 'd63'),
    exact: true
  },
  {
    path: '/sem/gaidxdb2',
    component: ComponentCreator('/sem/gaidxdb2', 'a90'),
    exact: true
  },
  {
    path: '/sem/gaidxdb3',
    component: ComponentCreator('/sem/gaidxdb3', 'eb3'),
    exact: true
  },
  {
    path: '/sem/gajsondb1',
    component: ComponentCreator('/sem/gajsondb1', '2ce'),
    exact: true
  },
  {
    path: '/sem/gajsondb2',
    component: ComponentCreator('/sem/gajsondb2', 'a5c'),
    exact: true
  },
  {
    path: '/sem/gajsondb3',
    component: ComponentCreator('/sem/gajsondb3', '020'),
    exact: true
  },
  {
    path: '/sem/galocal1',
    component: ComponentCreator('/sem/galocal1', 'f6d'),
    exact: true
  },
  {
    path: '/sem/galocal2',
    component: ComponentCreator('/sem/galocal2', '661'),
    exact: true
  },
  {
    path: '/sem/galocal3',
    component: ComponentCreator('/sem/galocal3', '4f9'),
    exact: true
  },
  {
    path: '/sem/garealm1',
    component: ComponentCreator('/sem/garealm1', '8b4'),
    exact: true
  },
  {
    path: '/sem/garealm2',
    component: ComponentCreator('/sem/garealm2', '02b'),
    exact: true
  },
  {
    path: '/sem/garealm3',
    component: ComponentCreator('/sem/garealm3', 'a5b'),
    exact: true
  },
  {
    path: '/sem/gatrso1',
    component: ComponentCreator('/sem/gatrso1', '7a2'),
    exact: true
  },
  {
    path: '/sem/gatrso2',
    component: ComponentCreator('/sem/gatrso2', '9c7'),
    exact: true
  },
  {
    path: '/sem/gatrso3',
    component: ComponentCreator('/sem/gatrso3', '290'),
    exact: true
  },
  {
    path: '/sem/gawmdb1',
    component: ComponentCreator('/sem/gawmdb1', '3a0'),
    exact: true
  },
  {
    path: '/sem/gawmdb2',
    component: ComponentCreator('/sem/gawmdb2', '845'),
    exact: true
  },
  {
    path: '/sem/gawmdb3',
    component: ComponentCreator('/sem/gawmdb3', '809'),
    exact: true
  },
  {
    path: '/sem/indexeddb-database',
    component: ComponentCreator('/sem/indexeddb-database', 'b06'),
    exact: true
  },
  {
    path: '/sem/indexeddb-database-2',
    component: ComponentCreator('/sem/indexeddb-database-2', 'e14'),
    exact: true
  },
  {
    path: '/sem/ionic-database',
    component: ComponentCreator('/sem/ionic-database', '102'),
    exact: true
  },
  {
    path: '/sem/localstorage-database',
    component: ComponentCreator('/sem/localstorage-database', '169'),
    exact: true
  },
  {
    path: '/sem/nedb-alternative',
    component: ComponentCreator('/sem/nedb-alternative', 'f4a'),
    exact: true
  },
  {
    path: '/sem/nodejs-database',
    component: ComponentCreator('/sem/nodejs-database', 'b04'),
    exact: true
  },
  {
    path: '/sem/nosql-database',
    component: ComponentCreator('/sem/nosql-database', '6b7'),
    exact: true
  },
  {
    path: '/sem/pouchdb-alternative',
    component: ComponentCreator('/sem/pouchdb-alternative', 'b71'),
    exact: true
  },
  {
    path: '/sem/react-database',
    component: ComponentCreator('/sem/react-database', 'ab6'),
    exact: true
  },
  {
    path: '/sem/react-native-database',
    component: ComponentCreator('/sem/react-native-database', '425'),
    exact: true
  },
  {
    path: '/sem/reddit',
    component: ComponentCreator('/sem/reddit', '4da'),
    exact: true
  },
  {
    path: '/sem/svelte-database',
    component: ComponentCreator('/sem/svelte-database', 'fdd'),
    exact: true
  },
  {
    path: '/sem/vue-database',
    component: ComponentCreator('/sem/vue-database', 'dfc'),
    exact: true
  },
  {
    path: '/sem/watermelondb-alternative',
    component: ComponentCreator('/sem/watermelondb-alternative', 'd56'),
    exact: true
  },
  {
    path: '/sem/ytube',
    component: ComponentCreator('/sem/ytube', '717'),
    exact: true
  },
  {
    path: '/service-submitted',
    component: ComponentCreator('/service-submitted', '3ce'),
    exact: true
  },
  {
    path: '/survey',
    component: ComponentCreator('/survey', 'bf5'),
    exact: true
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '/',
    component: ComponentCreator('/', 'f35'),
    routes: [
      {
        path: '/',
        component: ComponentCreator('/', '11f'),
        routes: [
          {
            path: '/',
            component: ComponentCreator('/', '611'),
            routes: [
              {
                path: '/adapters.html',
                component: ComponentCreator('/adapters.html', '2cd'),
                exact: true
              },
              {
                path: '/alternatives.html',
                component: ComponentCreator('/alternatives.html', '97b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/alternatives/absurd-sql-alternative.html',
                component: ComponentCreator('/articles/alternatives/absurd-sql-alternative.html', '488'),
                exact: true
              },
              {
                path: '/articles/alternatives/apollo-alternative.html',
                component: ComponentCreator('/articles/alternatives/apollo-alternative.html', 'd2a'),
                exact: true
              },
              {
                path: '/articles/alternatives/aws-amplify-datastore-alternative.html',
                component: ComponentCreator('/articles/alternatives/aws-amplify-datastore-alternative.html', '469'),
                exact: true
              },
              {
                path: '/articles/alternatives/cloudant-alternative.html',
                component: ComponentCreator('/articles/alternatives/cloudant-alternative.html', '6e5'),
                exact: true
              },
              {
                path: '/articles/alternatives/convex-alternative.html',
                component: ComponentCreator('/articles/alternatives/convex-alternative.html', '2d6'),
                exact: true
              },
              {
                path: '/articles/alternatives/couchbase-alternative.html',
                component: ComponentCreator('/articles/alternatives/couchbase-alternative.html', '0c9'),
                exact: true
              },
              {
                path: '/articles/alternatives/couchdb-alternative.html',
                component: ComponentCreator('/articles/alternatives/couchdb-alternative.html', '6fa'),
                exact: true
              },
              {
                path: '/articles/alternatives/dexie-alternative.html',
                component: ComponentCreator('/articles/alternatives/dexie-alternative.html', '880'),
                exact: true
              },
              {
                path: '/articles/alternatives/ditto-alternative.html',
                component: ComponentCreator('/articles/alternatives/ditto-alternative.html', '432'),
                exact: true
              },
              {
                path: '/articles/alternatives/electricsql-alternative.html',
                component: ComponentCreator('/articles/alternatives/electricsql-alternative.html', '2d3'),
                exact: true
              },
              {
                path: '/articles/alternatives/gundb-alternative.html',
                component: ComponentCreator('/articles/alternatives/gundb-alternative.html', '41c'),
                exact: true
              },
              {
                path: '/articles/alternatives/hoodie-alternative.html',
                component: ComponentCreator('/articles/alternatives/hoodie-alternative.html', '097'),
                exact: true
              },
              {
                path: '/articles/alternatives/horizon-alternative.html',
                component: ComponentCreator('/articles/alternatives/horizon-alternative.html', 'f69'),
                exact: true
              },
              {
                path: '/articles/alternatives/instantdb-alternative.html',
                component: ComponentCreator('/articles/alternatives/instantdb-alternative.html', '256'),
                exact: true
              },
              {
                path: '/articles/alternatives/localforage-alternative.html',
                component: ComponentCreator('/articles/alternatives/localforage-alternative.html', 'efa'),
                exact: true
              },
              {
                path: '/articles/alternatives/lokijs-alternative.html',
                component: ComponentCreator('/articles/alternatives/lokijs-alternative.html', 'e99'),
                exact: true
              },
              {
                path: '/articles/alternatives/lowdb-alternative.html',
                component: ComponentCreator('/articles/alternatives/lowdb-alternative.html', '8ea'),
                exact: true
              },
              {
                path: '/articles/alternatives/meteor-alternative.html',
                component: ComponentCreator('/articles/alternatives/meteor-alternative.html', 'c46'),
                exact: true
              },
              {
                path: '/articles/alternatives/minimongo-alternative.html',
                component: ComponentCreator('/articles/alternatives/minimongo-alternative.html', 'b48'),
                exact: true
              },
              {
                path: '/articles/alternatives/mongodb-realm-alternative.html',
                component: ComponentCreator('/articles/alternatives/mongodb-realm-alternative.html', 'a89'),
                exact: true
              },
              {
                path: '/articles/alternatives/nedb-alternative.html',
                component: ComponentCreator('/articles/alternatives/nedb-alternative.html', '8c0'),
                exact: true
              },
              {
                path: '/articles/alternatives/pouchdb-alternative.html',
                component: ComponentCreator('/articles/alternatives/pouchdb-alternative.html', '573'),
                exact: true
              },
              {
                path: '/articles/alternatives/powersync-alternative.html',
                component: ComponentCreator('/articles/alternatives/powersync-alternative.html', '711'),
                exact: true
              },
              {
                path: '/articles/alternatives/replicache-alternative.html',
                component: ComponentCreator('/articles/alternatives/replicache-alternative.html', 'c97'),
                exact: true
              },
              {
                path: '/articles/alternatives/rethinkdb-alternative.html',
                component: ComponentCreator('/articles/alternatives/rethinkdb-alternative.html', '0a2'),
                exact: true
              },
              {
                path: '/articles/alternatives/signaldb-alternative.html',
                component: ComponentCreator('/articles/alternatives/signaldb-alternative.html', '808'),
                exact: true
              },
              {
                path: '/articles/alternatives/sql-js-alternative.html',
                component: ComponentCreator('/articles/alternatives/sql-js-alternative.html', '782'),
                exact: true
              },
              {
                path: '/articles/alternatives/supabase-alternative.html',
                component: ComponentCreator('/articles/alternatives/supabase-alternative.html', '273'),
                exact: true
              },
              {
                path: '/articles/alternatives/turso-alternative.html',
                component: ComponentCreator('/articles/alternatives/turso-alternative.html', '84d'),
                exact: true
              },
              {
                path: '/articles/alternatives/watermelondb-alternative.html',
                component: ComponentCreator('/articles/alternatives/watermelondb-alternative.html', 'f1d'),
                exact: true
              },
              {
                path: '/articles/alternatives/yjs-alternative.html',
                component: ComponentCreator('/articles/alternatives/yjs-alternative.html', '888'),
                exact: true
              },
              {
                path: '/articles/angular-database.html',
                component: ComponentCreator('/articles/angular-database.html', 'efa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/angular-indexeddb.html',
                component: ComponentCreator('/articles/angular-indexeddb.html', '7e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/browser-database.html',
                component: ComponentCreator('/articles/browser-database.html', '530'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/browser-storage.html',
                component: ComponentCreator('/articles/browser-storage.html', '686'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/case-studies/venice-ai.html',
                component: ComponentCreator('/articles/case-studies/venice-ai.html', '215'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/data-base.html',
                component: ComponentCreator('/articles/data-base.html', '46f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/ddil-database.html',
                component: ComponentCreator('/articles/ddil-database.html', 'a7c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/electron-sqlite.html',
                component: ComponentCreator('/articles/electron-sqlite.html', '5d7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/embedded-database.html',
                component: ComponentCreator('/articles/embedded-database.html', 'aff'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/embeddinggemma-2-vector-search.html',
                component: ComponentCreator('/articles/embeddinggemma-2-vector-search.html', 'e30'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/firebase-realtime-database-alternative.html',
                component: ComponentCreator('/articles/firebase-realtime-database-alternative.html', '2dd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/firestore-alternative.html',
                component: ComponentCreator('/articles/firestore-alternative.html', '5ed'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/flutter-database.html',
                component: ComponentCreator('/articles/flutter-database.html', '65a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/frontend-database.html',
                component: ComponentCreator('/articles/frontend-database.html', '1b2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/generic-prompts.html',
                component: ComponentCreator('/articles/generic-prompts.html', 'b6a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/ideas',
                component: ComponentCreator('/articles/ideas', '260'),
                exact: true
              },
              {
                path: '/articles/in-memory-nosql-database.html',
                component: ComponentCreator('/articles/in-memory-nosql-database.html', 'a10'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/indexeddb-alternative.html',
                component: ComponentCreator('/articles/indexeddb-alternative.html', 'b58'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/indexeddb-max-storage-limit.html',
                component: ComponentCreator('/articles/indexeddb-max-storage-limit.html', 'ba4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/indexeddb/best-indexeddb-wrapper.html',
                component: ComponentCreator('/articles/indexeddb/best-indexeddb-wrapper.html', '37a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/indexeddb/indexeddb-encryption.html',
                component: ComponentCreator('/articles/indexeddb/indexeddb-encryption.html', 'b47'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/indexeddb/indexeddb-query.html',
                component: ComponentCreator('/articles/indexeddb/indexeddb-query.html', '617'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/indexeddb/indexeddb-relationships.html',
                component: ComponentCreator('/articles/indexeddb/indexeddb-relationships.html', '267'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/indexeddb/indexeddb-sync.html',
                component: ComponentCreator('/articles/indexeddb/indexeddb-sync.html', '031'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/indexeddb/indexeddb-tutorial.html',
                component: ComponentCreator('/articles/indexeddb/indexeddb-tutorial.html', '5da'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/indexeddb/indexeddb-typescript.html',
                component: ComponentCreator('/articles/indexeddb/indexeddb-typescript.html', 'c28'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/ionic-database.html',
                component: ComponentCreator('/articles/ionic-database.html', '1cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/ionic-storage.html',
                component: ComponentCreator('/articles/ionic-storage.html', '030'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/javascript-vector-database.html',
                component: ComponentCreator('/articles/javascript-vector-database.html', 'b8e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/jquery-database.html',
                component: ComponentCreator('/articles/jquery-database.html', 'dcf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/json-based-database.html',
                component: ComponentCreator('/articles/json-based-database.html', '4d2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/json-database.html',
                component: ComponentCreator('/articles/json-database.html', 'be6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/local-database.html',
                component: ComponentCreator('/articles/local-database.html', 'f62'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/local-first-future.html',
                component: ComponentCreator('/articles/local-first-future.html', '98a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/localstorage-indexeddb-cookies-opfs-sqlite-wasm.html',
                component: ComponentCreator('/articles/localstorage-indexeddb-cookies-opfs-sqlite-wasm.html', '048'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/localstorage.html',
                component: ComponentCreator('/articles/localstorage.html', '74f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/mobile-database.html',
                component: ComponentCreator('/articles/mobile-database.html', 'afd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/offline-database.html',
                component: ComponentCreator('/articles/offline-database.html', '45a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/optimistic-ui.html',
                component: ComponentCreator('/articles/optimistic-ui.html', 'df2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/progressive-web-app-database.html',
                component: ComponentCreator('/articles/progressive-web-app-database.html', '6da'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/react-database.html',
                component: ComponentCreator('/articles/react-database.html', '3ca'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/react-indexeddb.html',
                component: ComponentCreator('/articles/react-indexeddb.html', '6a5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/react-native-encryption.html',
                component: ComponentCreator('/articles/react-native-encryption.html', '853'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/reactjs-storage.html',
                component: ComponentCreator('/articles/reactjs-storage.html', '84b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/realm-to-rxdb-migration.html',
                component: ComponentCreator('/articles/realm-to-rxdb-migration.html', '9f6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/realtime-database.html',
                component: ComponentCreator('/articles/realtime-database.html', 'a55'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/rxdb-vs-sqlite-wasm-vs-pglite.html',
                component: ComponentCreator('/articles/rxdb-vs-sqlite-wasm-vs-pglite.html', 'fb3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/sqlite-sync.html',
                component: ComponentCreator('/articles/sqlite-sync.html', '8cf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/persist-tanstack-db-indexeddb.html',
                component: ComponentCreator('/articles/tanstack-db/persist-tanstack-db-indexeddb.html', 'df6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/rxdb-collection-for-tanstack-db.html',
                component: ComponentCreator('/articles/tanstack-db/rxdb-collection-for-tanstack-db.html', 'b8d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/sync-tanstack-db.html',
                component: ComponentCreator('/articles/tanstack-db/sync-tanstack-db.html', '4d9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-capacitor.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-capacitor.html', 'da3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-conflict-resolution.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-conflict-resolution.html', 'd72'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-couchdb-sync.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-couchdb-sync.html', '2e6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-electron.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-electron.html', 'f06'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-encryption.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-encryption.html', '40e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-graphql.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-graphql.html', '774'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-multi-tab.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-multi-tab.html', '54e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-offline-first.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-offline-first.html', 'e74'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-p2p-webrtc.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-p2p-webrtc.html', '090'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-pglite.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-pglite.html', '559'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-pwa.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-pwa.html', '741'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-react-native.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-react-native.html', 'c1d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-sqlite.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-sqlite.html', '807'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-db-supabase-offline.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-db-supabase-offline.html', 'bd9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/tanstack-query-offline-persistence-upgrade.html',
                component: ComponentCreator('/articles/tanstack-db/tanstack-query-offline-persistence-upgrade.html', 'b06'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/tanstack-db/what-is-tanstack-db.html',
                component: ComponentCreator('/articles/tanstack-db/what-is-tanstack-db.html', 'bd6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/vue-database.html',
                component: ComponentCreator('/articles/vue-database.html', '0f1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/vue-indexeddb.html',
                component: ComponentCreator('/articles/vue-indexeddb.html', 'f50'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/websockets-sse-polling-webrtc-webtransport.html',
                component: ComponentCreator('/articles/websockets-sse-polling-webrtc-webtransport.html', 'b3f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/articles/zero-latency-local-first.html',
                component: ComponentCreator('/articles/zero-latency-local-first.html', '394'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/backup.html',
                component: ComponentCreator('/backup.html', '245'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/capacitor-database.html',
                component: ComponentCreator('/capacitor-database.html', '967'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/cleanup.html',
                component: ComponentCreator('/cleanup.html', '817'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/contribution.html',
                component: ComponentCreator('/contribution.html', '306'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/crdt.html',
                component: ComponentCreator('/crdt.html', 'ef6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/data-migration.html',
                component: ComponentCreator('/data-migration.html', '802'),
                exact: true
              },
              {
                path: '/db-viewer.html',
                component: ComponentCreator('/db-viewer.html', '3a1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dev-mode.html',
                component: ComponentCreator('/dev-mode.html', '996'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/downsides-of-offline-first.html',
                component: ComponentCreator('/downsides-of-offline-first.html', '98b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/electron-database.html',
                component: ComponentCreator('/electron-database.html', '800'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/electron.html',
                component: ComponentCreator('/electron.html', '62b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/encryption.html',
                component: ComponentCreator('/encryption.html', '1d7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/errors.html',
                component: ComponentCreator('/errors.html', '2f1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/event-reduce.html',
                component: ComponentCreator('/event-reduce.html', 'aba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fulltext-search.html',
                component: ComponentCreator('/fulltext-search.html', '27a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/install.html',
                component: ComponentCreator('/install.html', '6a5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/json-import-export.html',
                component: ComponentCreator('/json-import-export.html', 'a55'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/key-compression.html',
                component: ComponentCreator('/key-compression.html', 'e68'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/leader-election.html',
                component: ComponentCreator('/leader-election.html', 'ba0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/logger.html',
                component: ComponentCreator('/logger.html', 'b51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/middleware.html',
                component: ComponentCreator('/middleware.html', '883'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/migration-schema.html',
                component: ComponentCreator('/migration-schema.html', '523'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/migration-storage.html',
                component: ComponentCreator('/migration-storage.html', '095'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/nodejs-database.html',
                component: ComponentCreator('/nodejs-database.html', '79e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/nosql-performance-tips.html',
                component: ComponentCreator('/nosql-performance-tips.html', 'b51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/offline-first.html',
                component: ComponentCreator('/offline-first.html', '878'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/orm.html',
                component: ComponentCreator('/orm.html', '132'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/overview.html',
                component: ComponentCreator('/overview.html', '91e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/partial-sync.html',
                component: ComponentCreator('/partial-sync.html', 'fe2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/plugins.html',
                component: ComponentCreator('/plugins.html', '383'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/population.html',
                component: ComponentCreator('/population.html', '83b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/query-builder.html',
                component: ComponentCreator('/query-builder.html', 'abe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/query-cache.html',
                component: ComponentCreator('/query-cache.html', '832'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/query-optimizer.html',
                component: ComponentCreator('/query-optimizer.html', '9b2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/quickstart.html',
                component: ComponentCreator('/quickstart.html', '3c4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/react-native-database.html',
                component: ComponentCreator('/react-native-database.html', '8ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/react.html',
                component: ComponentCreator('/react.html', 'dfa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/reactivity.html',
                component: ComponentCreator('/reactivity.html', '4c5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/10.0.0.html',
                component: ComponentCreator('/releases/10.0.0.html', '4ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/11.0.0.html',
                component: ComponentCreator('/releases/11.0.0.html', 'ef8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/12.0.0.html',
                component: ComponentCreator('/releases/12.0.0.html', '1ee'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/13.0.0.html',
                component: ComponentCreator('/releases/13.0.0.html', '3d7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/14.0.0.html',
                component: ComponentCreator('/releases/14.0.0.html', 'eea'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/15.0.0.html',
                component: ComponentCreator('/releases/15.0.0.html', 'c3d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/16.0.0.html',
                component: ComponentCreator('/releases/16.0.0.html', 'f30'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/17.0.0.html',
                component: ComponentCreator('/releases/17.0.0.html', '1ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/8.0.0.html',
                component: ComponentCreator('/releases/8.0.0.html', '9b6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/releases/9.0.0.html',
                component: ComponentCreator('/releases/9.0.0.html', '5c3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-appwrite.html',
                component: ComponentCreator('/replication-appwrite.html', '141'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-couchdb.html',
                component: ComponentCreator('/replication-couchdb.html', 'b77'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-firestore.html',
                component: ComponentCreator('/replication-firestore.html', 'f82'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-google-drive.html',
                component: ComponentCreator('/replication-google-drive.html', 'f8d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-graphql.html',
                component: ComponentCreator('/replication-graphql.html', '1db'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-http.html',
                component: ComponentCreator('/replication-http.html', 'a15'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-microsoft-onedrive.html',
                component: ComponentCreator('/replication-microsoft-onedrive.html', 'cca'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-mongodb.html',
                component: ComponentCreator('/replication-mongodb.html', '920'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-nats.html',
                component: ComponentCreator('/replication-nats.html', '4bf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-p2p.html',
                component: ComponentCreator('/replication-p2p.html', 'fc5'),
                exact: true
              },
              {
                path: '/replication-server.html',
                component: ComponentCreator('/replication-server.html', 'c8c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-supabase.html',
                component: ComponentCreator('/replication-supabase.html', 'c19'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-webrtc.html',
                component: ComponentCreator('/replication-webrtc.html', '44f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication-websocket.html',
                component: ComponentCreator('/replication-websocket.html', 'e6a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/replication.html',
                component: ComponentCreator('/replication.html', '502'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-attachment.html',
                component: ComponentCreator('/rx-attachment.html', 'fc2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-collection.html',
                component: ComponentCreator('/rx-collection.html', '728'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-database.html',
                component: ComponentCreator('/rx-database.html', '8b6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-document.html',
                component: ComponentCreator('/rx-document.html', 'a29'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-local-document.html',
                component: ComponentCreator('/rx-local-document.html', 'd6c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-pipeline.html',
                component: ComponentCreator('/rx-pipeline.html', '20b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-query-examples.html',
                component: ComponentCreator('/rx-query-examples.html', '2f8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-query.html',
                component: ComponentCreator('/rx-query.html', '4dd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-schema.html',
                component: ComponentCreator('/rx-schema.html', '711'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-server-scaling.html',
                component: ComponentCreator('/rx-server-scaling.html', '90e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-server.html',
                component: ComponentCreator('/rx-server.html', '328'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-state.html',
                component: ComponentCreator('/rx-state.html', '2e8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-denokv.html',
                component: ComponentCreator('/rx-storage-denokv.html', '0f8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-dexie.html',
                component: ComponentCreator('/rx-storage-dexie.html', '413'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-filesystem-expo.html',
                component: ComponentCreator('/rx-storage-filesystem-expo.html', 'e34'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-filesystem-node.html',
                component: ComponentCreator('/rx-storage-filesystem-node.html', 'a2a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-foundationdb.html',
                component: ComponentCreator('/rx-storage-foundationdb.html', 'bf5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-indexeddb.html',
                component: ComponentCreator('/rx-storage-indexeddb.html', '38a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-localstorage-meta-optimizer.html',
                component: ComponentCreator('/rx-storage-localstorage-meta-optimizer.html', '4ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-localstorage.html',
                component: ComponentCreator('/rx-storage-localstorage.html', 'e7b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-lokijs.html',
                component: ComponentCreator('/rx-storage-lokijs.html', 'fa4'),
                exact: true
              },
              {
                path: '/rx-storage-memory-mapped.html',
                component: ComponentCreator('/rx-storage-memory-mapped.html', 'ec4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-memory-synced.html',
                component: ComponentCreator('/rx-storage-memory-synced.html', 'c06'),
                exact: true
              },
              {
                path: '/rx-storage-memory.html',
                component: ComponentCreator('/rx-storage-memory.html', 'c26'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-mongodb.html',
                component: ComponentCreator('/rx-storage-mongodb.html', '248'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-opfs.html',
                component: ComponentCreator('/rx-storage-opfs.html', '45e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-performance.html',
                component: ComponentCreator('/rx-storage-performance.html', '0c0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-pouchdb.html',
                component: ComponentCreator('/rx-storage-pouchdb.html', '421'),
                exact: true
              },
              {
                path: '/rx-storage-remote.html',
                component: ComponentCreator('/rx-storage-remote.html', '6c5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-sharding.html',
                component: ComponentCreator('/rx-storage-sharding.html', 'bf6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-shared-worker.html',
                component: ComponentCreator('/rx-storage-shared-worker.html', '955'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-sqlite.html',
                component: ComponentCreator('/rx-storage-sqlite.html', 'c7b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage-worker.html',
                component: ComponentCreator('/rx-storage-worker.html', 'f85'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rx-storage.html',
                component: ComponentCreator('/rx-storage.html', 'e34'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rxdb-tradeoffs.html',
                component: ComponentCreator('/rxdb-tradeoffs.html', '481'),
                exact: true
              },
              {
                path: '/schema-validation.html',
                component: ComponentCreator('/schema-validation.html', '097'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/slow-indexeddb.html',
                component: ComponentCreator('/slow-indexeddb.html', '54a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/testing.html',
                component: ComponentCreator('/testing.html', '5cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/third-party-plugins.html',
                component: ComponentCreator('/third-party-plugins.html', '771'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/transactions-conflicts-revisions.html',
                component: ComponentCreator('/transactions-conflicts-revisions.html', '1ea'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/tutorials/typescript.html',
                component: ComponentCreator('/tutorials/typescript.html', 'ea5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/webmcp.html',
                component: ComponentCreator('/webmcp.html', 'eb4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/why-nosql.html',
                component: ComponentCreator('/why-nosql.html', 'b71'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
